import React, { useState, useEffect } from 'react';
import "./Loader.scss";

// Loader component
const Loader = () => {
  return (
    <div className="loader-container">
        <span className="timer-loader">Loading&#8230;</span>
    </div>
  );
};
export default Loader